(() => {
  if (window.PaleoCartAnimation) return;

  const isVisible = element => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  };

  const findCartTarget = () => {
    const selectors = [
      '.sticky-header.show .mobile-cart-button',
      '.sticky-header.show .button--cart-handle',
      '#site-header .mobile-cart-button',
      '#site-header .button--cart-handle'
    ];

    return selectors.map(selector => document.querySelector(selector)).find(isVisible) || null;
  };

  const findProductImage = trigger => {
    const product = trigger?.closest('[data-js-product-item], [data-index], .product-item, .product-card');
    if (!product) return null;

    return [...product.querySelectorAll('img')].find(image => isVisible(image) && (image.currentSrc || image.src)) || null;
  };

  const pulseTarget = target => {
    if (!target) return;
    target.classList.remove('cart-fly-target-pulse');
    void target.offsetWidth;
    target.classList.add('cart-fly-target-pulse');
    window.setTimeout(() => target.classList.remove('cart-fly-target-pulse'), 450);
  };

  const play = trigger => {
    const target = findCartTarget();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      pulseTarget(target);
      return;
    }

    const image = findProductImage(trigger);
    const sourceRect = (image || trigger)?.getBoundingClientRect();
    if (!sourceRect) {
      pulseTarget(target);
      return;
    }

    const targetRect = target?.getBoundingClientRect();
    const circleSize = 92;
    const startX = sourceRect.left + (sourceRect.width - circleSize) / 2;
    const startY = sourceRect.top + (sourceRect.height - circleSize) / 2;
    const endCenterX = targetRect
      ? targetRect.left + targetRect.width / 2
      : (document.documentElement.dir === 'rtl' ? 28 : window.innerWidth - 28);
    const endCenterY = targetRect ? targetRect.top + targetRect.height / 2 : 18;
    const moveX = endCenterX - (startX + circleSize / 2);
    const moveY = endCenterY - (startY + circleSize / 2);

    const flyer = image ? document.createElement('img') : document.createElement('span');
    flyer.className = `cart-fly-product${image ? '' : ' cart-fly-product--fallback'}`;
    flyer.setAttribute('aria-hidden', 'true');
    if (image) {
      flyer.src = image.currentSrc || image.src;
      flyer.alt = '';
    }
    Object.assign(flyer.style, {
      left: `${startX}px`,
      top: `${startY}px`,
      width: `${circleSize}px`,
      height: `${circleSize}px`
    });
    document.body.appendChild(flyer);

    const animation = flyer.animate([
      {
        opacity: 1,
        transform: 'translate3d(0, 0, 0) scale(1)'
      },
      {
        opacity: 0.15,
        transform: `translate3d(${moveX}px, ${moveY}px, 0) scale(0.45)`
      }
    ], {
      duration: 880,
      easing: 'cubic-bezier(0.2, 0.75, 0.25, 1)',
      fill: 'forwards'
    });

    animation.finished
      .catch(() => {})
      .then(() => {
        flyer.remove();
        pulseTarget(target);
      });
  };

  window.PaleoCartAnimation = { play };
})();
